<wk-icon-arrow-left-sprite-pds3 />
<wk-icon-arrow-right-sprite-pds3 />

<simple-table-pds3 #table flowClass="wk-data-table__container">
    <table #tableHead wk-data-table-header>
        <tbody class="wk-data-table__body">
            @if (!dataTableDraggingService.isDragging()) {
                @for (item of itemsInPage(); track trackByPrimaryField($index, item); let idx = $index) {
                    <tr wk-data-table-item [index]="pageStart() + idx"></tr>
                }
            }
            @if (itemsInPage().length < resultsPerPage() || dataTableDraggingService.isDragging()) {
                <tr class="wk-data-table__item wk-data-table__item--empty">
                    <td
                        [attr.colspan]="
                            dataTableStore.visibleColumns().length +
                            (dataTableContext.selectable() ? 1 : 0) +
                            (dataTableContext.actions().length ? 1 : 0)
                        "
                    ></td>
                </tr>
            }
        </tbody>
    </table>
</simple-table-pds3>

@if (getPagesCount() > 1) {
    <pagination-bar-pds3
        flowClass="wk-data-table__footer__pagination-bar"
        [hasTextBar]="true"
        [totalResults]="items().length"
        [resultsPerPage]="resultsPerPage()"
        [availableResultsPerPage]="[]"
        [currentPage]="currentPage()"
        [pagesCount]="getPagesCount()"
        (openPage)="openPage($any($event))"
        (resultsPerPageChange)="onResultsPerPageChange($any($event))"
    />
}
